//#region importStatements
import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { GetLanguageString } from "../../../helper/Components";
import { LoadingSpinner } from "../../../../constants/const";
import Draggable from "react-draggable";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method";
import { useTranslation } from "react-i18next";
import { addMember, setupApi } from "../../../member/ApiMember";
import Select from "react-select";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import swal from "sweetalert";
import { FiEdit2 } from "react-icons/fi";
import { FaTrash } from "react-icons/fa";

//#endregion importStatements

const AddNewBankAccount = ({
  setModal,
  getAddedBankAccount,
  setRefreshBankList,
}) => {
  //#region useStateHooks
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const { t } = useTranslation();

  const [values, setValues] = useState({
    bankId: null,
    accountTitle: "",
    accountNumber: "",
    accountIban: "",
    accountBranch: "",
    unitId: loggedInUnitId,
    memberId: null,
  });

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [errors, setErrors] = useState({});
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const [loading, setLoading] = useState(false);
  const [accountLoading, setAccountLoading] = useState(false);
  const [editingAccountId, setEditingAccountId] = useState(null);

  const [disablesubmitButton, setDisableSubmitButton] = useState(true);
  const [banksList, setBanksList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [responsibleMembers, setResponsibleMembers] = useState([]);
  const [selectedResponsibleMember, setSelectedResponsibleMember] =
    useState(null);

  const [GetMemberBankAccounts, setMemberBankAccounts] = useState([]);
  //#endregion useStateHooks

  //#region useEffectHooks
  useEffect(() => {
    setLoading(true);
    addMember()
      .GetResponsibleMemberUnitId(loggedInUnitId)
      .then((res) => {
        setResponsibleMembers(res.data);
        setSelectedResponsibleMember(res.data[0]);

        if (res.data.length > 0) {
          handlechangeMember(res.data[0]);
        }
      })
      .finally(() => setLoading(false));
  }, [loggedInUnitId]);

  useEffect(() => {
    setLoading(true);
    setupApi()
      .GetAllBanks()
      .then((res) => {
        setBanksList(res.data);
        setSelectedBank(res.data[0]);
        setValues((prev) => ({ ...prev, bankId: res.data[0].value }));
      })
      .finally(() => setLoading(false));
  }, []);
  //#endregion useEffectHooks

  //#region helperFunctions

  const DeleteMemberBankAccount = (accountId) => {
    // const { value } = e.target;
    //const value = selectedTransNo;
    swal({
      title: t("common_delete_message"),
      text: t("common_delete_detail_message"),
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        addMember()
          .DeleteMemberBankAccount(accountId)
          .then((res) => {
            //handleSearch();
            if (res.data.statusCode === "200") {
              swal({
                title: t("transaction_deleted"),
                className: GetSelectedLanguage() === "en" ? "" : "ur",
                icon: "success",
                buttons: "OK",
              });
              handlechangeMember(selectedResponsibleMember);
            } else {
              swal({
                title: t(res.data.message),
                icon: "error",
                buttons: "OK",
              });
            }
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: t(err?.message || "error_occurred"),
              icon: "error",
              buttons: "OK",
            });
            setLoading(false);
          });
      }
    });
  };

  const toggle = () => setModal(false);

  const handleInputChange = (e) => {
    setDisableSubmitButton(false);
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const handlechangeMember = (selectedOption) => {
    setSelectedResponsibleMember(selectedOption);
    setValues((prev) => ({
      ...prev,
      memberId: selectedOption.value,
    }));

    setErrors((prev) => ({ ...prev, member: "" }));

    setAccountLoading(true);
    addMember()
      .GetMemberBankAccount(selectedOption.value)
      .then((res) => setMemberBankAccounts(res.data))
      .finally(() => setAccountLoading(false));
  };

  const validate = () => {
    const temp = {};

    temp.member = selectedResponsibleMember
      ? ""
      : t("common_field_required_error");

    temp.selectedBank = selectedBank ? "" : t("common_field_required_error");

    temp.accountTitle = values.accountTitle
      ? ""
      : t("common_field_required_error");

    temp.accountNumber = values.accountNumber
      ? ""
      : t("common_field_required_error");

    temp.accountIban = values.accountIban ? "" : "";
    temp.accountBranch = values.accountBranch ? "" : "";

    setErrors(temp);

    return Object.values(temp).every((x) => x === "");
  };

  const handleChangeBank = (selectedOption) => {
    setSelectedBank(selectedOption);
    setValues((prev) => ({ ...prev, bankId: selectedOption.value }));
    setErrors((prev) => ({ ...prev, selectedBank: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }
    setLoading(true);
    const apiCall = editingAccountId
      ? addMember().UpdateMemberBankAccount({
          ...values,
          id: editingAccountId,
        })
      : addMember().AddMemberBankAccount(values);
    apiCall
      .then((res) => {
        if (res.data.statusCode === "200") {
          swal({
            title: t("transactions_bank_account_added"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: "OK",
          });
          var addedAccount = res.data.addedAccount;
          getAddedBankAccount(addedAccount);
          setRefreshBankList(true);
          toggle();
          handlechangeMember(selectedResponsibleMember);

          setEditingAccountId(null);
          setDisableSubmitButton(true);
        }
      })
      .catch((error) => {
        swal({
          title: error,
          icon: "error",
          buttons: "OK",
        });
        console.error("There was an error adding the bank account!", error);
      })
      .finally(() => {
        setLoading(false);

        // API call next…
      });
  };
  //#endregion helperFunctions

  const handleEditBankAccount = (acc) => {
    setEditingAccountId(acc.id);

    setValues((prev) => ({
      ...prev,
      bankId: acc.bankId,
      accountTitle: acc.accountTitle,
      accountNumber: acc.accountNumber,
      accountIban: acc.accountIban,
      accountBranch: acc.accountBranch,
    }));

    setSelectedBank({
      label: acc.bankName,
      value: acc.bankId,
    });

    setDisableSubmitButton(false);
  };

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen className="inmodal" size="lg" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          {editingAccountId ? (
            <GetLanguageString props="transactions_update_rafiq_bank_details" />
          ) : (
            <GetLanguageString props="transactions_rafiq_bank_details" />
          )}
        </ModalHeader>

        {loading ? (
          <ModalBody>
            <div className="text-center" style={{ width: "100%" }}>
              <LoadingSpinner />
            </div>
          </ModalBody>
        ) : (
          <>
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                {/* MEMBER */}
                <Row>
                  <Col md="12">
                    <FormGroup>
                      <Label className="col-form-label">
                        <GetLanguageString props="sidebar_member" />
                      </Label>
                      <Select
                        className="ur"
                        options={responsibleMembers}
                        value={selectedResponsibleMember}
                        onChange={handlechangeMember}
                      />
                      {errors.member && (
                        <div className="invalid-feedback d-block">
                          <h4>{errors.member}</h4>
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* EXISTING ACCOUNTS */}
                  <Col md="12">
                    <FormGroup>
                      {accountLoading ? (
                        <div className="text-center" style={{ width: "100%" }}>
                          <LoadingSpinner />
                        </div>
                      ) : (
                        <Row className="mt-2">
                          {GetMemberBankAccounts.map((acc) => (
                            <Col md="6" key={acc.id} className="mb-3">
                              {editingAccountId ? (
                                <></>
                              ) : (
                                <div
                                  style={{
                                    background: "#ffffff",
                                    borderRadius: 10,
                                    border: "1px solid #e0e0e0",
                                    padding: "15px",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                  }}
                                >
                                  {/* Title Row */}
                                  <Row className="align-items-center mb-2">
                                    <Col className="text-end">
                                      <FiEdit2
                                        size={16}
                                        style={{
                                          cursor: "pointer",
                                          color: "#0d6efd",
                                          marginRight: 8,
                                        }}
                                        title="Edit"
                                        onClick={() =>
                                          handleEditBankAccount(acc)
                                        }
                                      />
                                      <FaTrash
                                        size={16}
                                        style={{
                                          cursor: "pointer",
                                          color: "#dc3545",
                                        }}
                                        title="Delete"
                                        onClick={() =>
                                          DeleteMemberBankAccount(acc.id)
                                        }
                                      />
                                    </Col>
                                  </Row>

                                  {/* Body Row */}
                                  <Row>
                                    <>
                                      <Col>
                                        <div
                                          style={{
                                            marginBottom: 8,
                                            color: "#555",
                                          }}
                                        >
                                          {acc.accountTitle} -{" "}
                                          {acc.accountBranch}
                                        </div>
                                      </Col>
                                      <Col
                                        xs="12"
                                        style={{
                                          color: "#555",
                                          marginBottom: 4,
                                        }}
                                      >
                                        <strong>Account Number:</strong>{" "}
                                        {acc.accountNumber}
                                      </Col>
                                      <Col
                                        xs="12"
                                        style={{
                                          color: "#555",
                                          marginBottom: 4,
                                        }}
                                      >
                                        <strong>Bank Name:</strong>{" "}
                                        {acc.bankName}
                                      </Col>
                                      <Col xs="12" style={{ color: "#555" }}>
                                        <strong>IBAN:</strong> {acc.accountIban}
                                      </Col>
                                    </>
                                  </Row>
                                </div>
                              )}
                            </Col>
                          ))}
                        </Row>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                {/* FORM INPUTS */}
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="col-form-label">
                        <GetLanguageString props="transactions_bank_name" />
                      </Label>
                      <Select
                        options={banksList}
                        value={selectedBank}
                        onChange={handleChangeBank}
                      />
                      {errors.selectedBank && (
                        <div className="invalid-feedback d-block">
                          <h4>{errors.selectedBank}</h4>
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <Label className="col-form-label">
                        <GetLanguageString props="transactions_account_title" />
                      </Label>
                      <Input
                        type="text"
                        name="accountTitle"
                        value={values.accountTitle}
                        onChange={handleInputChange}
                        invalid={!!errors.accountTitle}
                      />
                      <FormFeedback>
                        <h4>{errors.accountTitle}</h4>
                      </FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <Label className="col-form-label">
                        <GetLanguageString props="transactions_account_number" />
                      </Label>
                      <Input
                        type="text"
                        name="accountNumber"
                        value={values.accountNumber}
                        onChange={handleInputChange}
                        invalid={!!errors.accountNumber}
                      />
                      <FormFeedback>
                        <h4>{errors.accountNumber}</h4>
                      </FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <Label className="col-form-label">
                        <GetLanguageString props="transactions_account_iban" />
                      </Label>
                      <Input
                        type="text"
                        name="accountIban"
                        value={values.accountIban}
                        onChange={handleInputChange}
                        invalid={!!errors.accountIban}
                      />
                      <FormFeedback>
                        <h4>{errors.accountIban}</h4>
                      </FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <Label className="col-form-label">
                        <GetLanguageString props="transactions_account_branch" />
                      </Label>
                      <Input
                        type="text"
                        name="accountBranch"
                        value={values.accountBranch}
                        onChange={handleInputChange}
                        invalid={!!errors.accountBranch}
                      />
                      <FormFeedback>
                        <h4>{errors.accountBranch}</h4>
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>

              <ModalFooter>
                <Row
                  style={{
                    backgroundColor: "white",
                    marginLeft: 2,
                    marginRight: 2,
                    height: 50,
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      marginTop: 10,
                      display: "flex",
                      gap: 10,
                      justifyContent: "flex-end",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      color="white"
                      className={GetCustomStyles().btn_style}
                      onClick={() => {
                        if (editingAccountId) {
                          setEditingAccountId(null);
                          setValues((prev) => ({
                            ...prev,
                            accountTitle: "",
                            accountNumber: "",
                            accountIban: "",
                            accountBranch: "",
                          }));
                        } else {
                          toggle();
                        }
                      }}
                    >
                      {editingAccountId ? (
                        <GetLanguageString props="transactions_clear_btn" />
                      ) : (
                        <GetLanguageString props="common_cancel" />
                      )}
                    </Button>
                    <Button
                      color="primary"
                      className={GetCustomStyles().btn_style}
                      disabled={disablesubmitButton}
                      type="submit"
                    >
                      {editingAccountId ? (
                        "Update Bank Account"
                      ) : (
                        <GetLanguageString props="common_save_changes" />
                      )}
                    </Button>
                  </div>
                </Row>
              </ModalFooter>
            </Form>
          </>
        )}
      </Modal>
    </Draggable>
  );
};

export default AddNewBankAccount;
